const messages = {
    uploadImg: 'آپلود تصویر',
    select: {
        otherOption: 'گزینه دیگر'
    },
    submitForm: 'ثبت فرم',
    cancel: 'لغو'
};
export default messages;
